<template>
  <div class="submit_table_v1">
    <div class="col-12 pt-3" v-if="notEmptyObject(recs)">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-12 bp_color">
                  <strong style="display: inline-block; width: 265px;">Workers
                    <span v-if="$store.state.auth.me.roles.includes('client_sub')">submitted</span>
                    <span v-if="$store.state.auth.me.roles.includes('client_auth')">authorised</span>
                    :</strong>
                  <span class="d-inline-block">{{ calc_left_submit }}</span>
                </div>
                <div class="col-12" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <strong style="display: inline-block; width: 265px;">Total before Additions & Deductions:</strong>
                  <span class="d-inline-block">{{ tots.total_b4_add_ded | currency }}</span>
                </div>
                <div class="col-12" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <strong style="display: inline-block; width: 265px;">Retention Total:</strong>
                  <span class="d-inline-block">{{ tots.retention_total | currency }}</span>
                </div>
                <div class="col-12 bp_color">
                  <strong style="display: inline-block; width: 265px;">Invoice Total:</strong>
                  <span class="d-inline-block">{{ tots.invoice_total | currency }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-12" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <strong style="display: inline-block; width: 265px;">Pre Tax Additions Total:</strong>
                  <span class="d-inline-block">{{ tots.pre_tax_add_total | currency }}</span>
                </div>
                <div class="col-12" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <strong style="display: inline-block; width: 265px;">Post Tax Additions Total:</strong>
                  <span class="d-inline-block">{{ tots.post_tax_add_total | currency }}</span>
                </div>
                <div class="col-12" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <strong style="display: inline-block; width: 265px;">Pre Tax Deductions Total:</strong>
                  <span class="d-inline-block">{{ tots.pre_tax_ded_total | currency }}</span>
                </div>
                <div class="col-12" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <strong style="display: inline-block; width: 265px;">Post Tax Deductions Total:</strong>
                  <span class="d-inline-block">{{ tots.post_tax_ded_total | currency }}</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr class="mt-2 mb-3">
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="table-responsive mb-3" style="overflow-x: visible">
            <table class="table table-striped table-sm" id="timesheet_submit_table">
              <thead>
              <tr>
                <th scope="col" class="firstName">First Name</th>
                <th scope="col" class="surname">Surname</th>
                <th scope="col" class="jobTitle">Job Title</th>
                <th scope="col" class="payRate" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Pay/Rate Type</th>
                <th scope="col" class="payRate" v-if="crmType === 'recruitment' && $store.state.auth.me.recruitment">Charge Rate</th>
                <th scope="col" class="payRate" v-else>Pay Rate</th>

                <th scope="col" class="days" v-for="d in week">
                  <div><span>{{ d }}</span></div>
                </th>

                <th scope="col" class="hours_invoice" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Hours</th>
                <th scope="col" class="hours_invoice" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Invoice</th>

                <th scope="col" class="totalHours">Total Units</th>

                <th scope="col" class="totalHours" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Total<br><span style="font-size: 0.6rem;">Before additions & deductions</span></th>

                <th scope="col" class="releaseRetention" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Release Retention<br><span style="font-size: 0.6rem;">(Percentage)</span></th>
                <th scope="col" class="releaseRetentionAmount" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Retention Amount</th>

                <th scope="col" class="additionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Pre-Tax Addition/Description</th>
                <th scope="col" class="additionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Post-Tax Addition/Description</th>
                <th scope="col" class="deductionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Pre-Tax Deduction/Description</th>
                <th scope="col" class="deductionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">Post-Tax Deduction/Description</th>

                <th scope="col" class="totalHours">Invoice Total</th>

                <th scope="col" class="backNextWeek">Back Next Week</th>

                <th scope="col" class="totalHours">With</th>

                <th v-if="$store.state.auth.me.roles.includes('client_auth')" scope="col" class="submitPayroll">Submit for Auth</th>
                <th v-else-if="$store.state.auth.me.roles.includes('client_sub')" scope="col" class="submitPayroll">
                  Submit to <span v-if="crmType === 'payroll'">Genius</span><span v-else-if="crmType === 'recruitment'">V3</span>
                </th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="(a, i) in recs">
                <td class="firstName">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.first_name }}</div>
                  </div>
                </td>
                <td class="surname">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.surname }}</div>
                  </div>
                </td>
                <td class="jobTitle">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.job_title }}</div>
                  </div>
                </td>
                <td class="payRate" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.pay_type }}/{{ a.rate_type }}</div>
                  </div>
                </td>
                <td class="payRate">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.pay_rate | currency }}</div>
                  </div>
                </td>

                <td class="days" v-for="ts_p in a.timesheet_pay">
                  <vue-numeric style="background: transparent;" separator="," :precision="4" :minus="false" v-model="ts_p.price"
                               :disabled="a.auth_level >= a.contact_job_auth_level" @change="calc_assignment_values(i)"
                               class="timesheet_input" :class="[isDisabled(a)]"></vue-numeric>
                </td>

                <td class="hours_invoice" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <button v-if="a.pay_type === 'Price'" class="btn orcaBtn greenBtn sm_btn" style="margin-top: 8px;"
                          @click="show_hours(a.timesheet_pay, a.first_name, a.surname)">
                    <i class="fas fa-clock"></i></button>
                  <div v-else class="td_data_outer">
                    -
                  </div>
                </td>
                <td class="hours_invoice" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <button v-if="a.timesheet_worker_invoice === null" class="btn orcaBtn grey_bg sm_btn" style="margin-top: 8px;"
                          disabled><i class="fas fa-file-invoice"></i></button>
                  <button v-else-if="a.worker_submitted" class="btn orcaBtn greenBtn sm_btn" style="margin-top: 8px;"
                          @click="show_invoice(a.ts_record, a.first_name, a.surname)">
                    <i class="fas fa-file-invoice"></i></button>
                  <button v-else class="btn orcaBtn warning sm_btn" style="margin-top: 8px;"
                          @click="show_invoice(a.ts_record, a.first_name, a.surname)"><i class="fas fa-file-invoice"></i></button>
                </td>

                <td class="totalHours">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.total_units }}</div>
                  </div>
                </td>
                <td class="totalHours" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.total_before_additions_deductions | currency }}</div>
                  </div>
                </td>

                <td class="releaseRetention" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">
                      <p-check class="p-icon p-smooth" v-model="a.retention_released" @change="calc_assignment_values(i)"
                               :disabled="a.auth_level >= a.contact_job_auth_level">
                        <i slot="extra" class="icon fa fa-check"></i>
                      </p-check>
                      <span class="d-inline-block" style="font-size: 0.8rem; margin-left: 5px; line-height: 22px">{{ a.retention_percentage | percentage }}</span>
                    </div>
                  </div>
                </td>
                <td class="releaseRetentionAmount" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.retention_amount | currency }}</div>
                  </div>
                </td>

                <td class="additionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div v-for="(pta, k) in a.addition_pre_tax" class="row ml-0 mr-0">
                    <div class="col-2 pl-0 pr-0 text-center" v-if="!(a.auth_level >= a.contact_job_auth_level)">
                      <button @click="del_pre_tax_addition(i, k)" class="btn orcaBtn sm_btn danger" style="padding: 0 10px;">
                        <i class="fas fa-trash-alt"></i></button>
                    </div>
                    <div :class="[(a.auth_level >= a.contact_job_auth_level) ? 'col-5' : 'col-3', 'pl-0', 'pr-0']">
                      <vue-numeric style="background: transparent;" currency="£" separator="," :precision="2" :minus="false" v-model="pta.amount"
                                   class="timesheet_input" :class="[isDisabled(a)]" :id="'value_pre_add_' + i + '_' + k"
                                   @change="calc_assignment_values(i)" @blur="go_to_details('desc_pre_add_', i, k)"
                                   :disabled="a.auth_level >= a.contact_job_auth_level"></vue-numeric>
                    </div>
                    <div class="col-7 pl-0 pr-0">
                      <multiselect v-model="pta.desc" :id="'desc_pre_add_' + i + '_' + k" :name="'desc_pre_add_' + i + '_' + k" placeholder=""
                                   :options="ms_opts.pre_add" @open="repositionDropdown" label="value" trackBy="id" :show-labels="false"
                                   :disabled="a.auth_level >= a.contact_job_auth_level" :allow-empty="false"
                                   :ref="'desc_pre_add_' + i + '_' + k" @close="close_details('desc_pre_add_', pta, i, k)"
                                   :selectLabel="''"></multiselect>
                    </div>
                  </div>
                  <div v-if="!(a.auth_level >= a.contact_job_auth_level)">
                    <div v-if="a.addition_pre_tax.length > 0">
                      <button v-if="a.addition_pre_tax[a.addition_pre_tax.length - 1].amount !== 0 && a.addition_pre_tax[a.addition_pre_tax.length - 1].desc !== null"
                              @click="add_pre_tax_addition(i)" class="btn orcaBtn sm_btn grey_bg ml-1">
                        <i class="fas fa-plus mr-2"></i>Pre-Tax Addition
                      </button>
                    </div>
                    <div v-else>
                      <button @click="add_pre_tax_addition(i)" class="btn orcaBtn sm_btn grey_bg ml-1"><i class="fas fa-plus mr-2"></i>Pre-Tax Addition</button>
                    </div>
                  </div>
                </td>
                <td class="additionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div v-for="(pta, k) in a.addition_post_tax" class="row ml-0 mr-0">
                    <div class="col-2 pl-0 pr-0 text-center" v-if="!(a.auth_level >= a.contact_job_auth_level)">
                      <button @click="del_post_tax_addition(i, k)" class="btn orcaBtn sm_btn danger" style="padding: 0 10px;">
                        <i class="fas fa-trash-alt"></i></button>
                    </div>
                    <div :class="[(a.auth_level >= a.contact_job_auth_level) ? 'col-5' : 'col-3', 'pl-0', 'pr-0']">
                      <vue-numeric style="background: transparent;" currency="£" separator="," :precision="2" :minus="false" v-model="pta.amount"
                                   class="timesheet_input" :class="[isDisabled(a)]"
                                   @change="calc_assignment_values(i)" @blur="go_to_details('desc_post_add_', i, k)"
                                   :disabled="a.auth_level >= a.contact_job_auth_level"></vue-numeric>
                    </div>
                    <div class="col-7 pl-0 pr-0">
                      <multiselect v-model="pta.desc" :id="'desc_post_add_' + i + '_' + k" :name="'desc_post_add_' + i + '_' + k" placeholder=""
                                   :options="ms_opts.post_add" @open="repositionDropdown" label="value"
                                   :disabled="a.auth_level >= a.contact_job_auth_level" :allow-empty="false"
                                   :ref="'desc_post_add_' + i + '_' + k" @close="close_details('desc_post_add_', pta, i, k)"
                                   :selectLabel="''"></multiselect>
                    </div>
                  </div>
                  <div v-if="!(a.auth_level >= a.contact_job_auth_level)">
                    <div v-if="a.addition_post_tax.length > 0">
                      <button v-if="a.addition_post_tax[a.addition_post_tax.length - 1].amount !== 0 && a.addition_post_tax[a.addition_post_tax.length - 1].desc !== null"
                              @click="add_post_tax_addition(i)" class="btn orcaBtn sm_btn grey_bg ml-1">
                        <i class="fas fa-plus mr-2"></i>Post-Tax Addition
                      </button>
                    </div>
                    <div v-else>
                      <button @click="add_post_tax_addition(i)" class="btn orcaBtn sm_btn grey_bg ml-1"><i class="fas fa-plus mr-2"></i>Post-Tax Addition</button>
                    </div>
                  </div>
                </td>
                <td class="deductionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div v-for="(pta, k) in a.deduction_pre_tax" class="row ml-0 mr-0">
                    <div class="col-2 pl-0 pr-0 text-center" v-if="!(a.auth_level >= a.contact_job_auth_level)">
                      <button @click="del_pre_tax_deduction(i, k)" class="btn orcaBtn sm_btn danger" style="padding: 0 10px;">
                        <i class="fas fa-trash-alt"></i></button>
                    </div>
                    <div :class="[(a.auth_level >= a.contact_job_auth_level) ? 'col-5' : 'col-3', 'pl-0', 'pr-0']">
                      <vue-numeric style="background: transparent;" currency="£" separator="," :precision="2" :minus="false" v-model="pta.amount"
                                   class="timesheet_input" :class="[isDisabled(a)]"
                                   @change="calc_assignment_values(i)" @blur="go_to_details('desc_pre_ded_', i, k)"
                                   :disabled="a.auth_level >= a.contact_job_auth_level"></vue-numeric>
                    </div>
                    <div class="col-7 pl-0 pr-0">
                      <multiselect v-model="pta.desc" :id="'desc_pre_ded_' + i + '_' + k" :name="'desc_pre_ded_' + i + '_' + k" placeholder="" :options="ms_opts.pre_ded"
                                   @open="repositionDropdown" label="value"
                                   :disabled="a.auth_level >= a.contact_job_auth_level" :allow-empty="false"
                                   :ref="'desc_pre_ded_' + i + '_' + k" @close="close_details('desc_pre_ded_', pta, i, k)"
                                   :selectLabel="''"></multiselect>
                    </div>
                  </div>
                  <div v-if="!(a.auth_level >= a.contact_job_auth_level)">
                    <div v-if="a.deduction_pre_tax.length > 0">
                      <button v-if="a.deduction_pre_tax[a.deduction_pre_tax.length - 1].amount !== 0 && a.deduction_pre_tax[a.deduction_pre_tax.length - 1].desc !== null"
                              @click="add_pre_tax_deduction(i)" class="btn orcaBtn sm_btn grey_bg ml-1">
                        <i class="fas fa-plus mr-2"></i>Pre-Tax Deduction
                      </button>
                    </div>
                    <div v-else>
                      <button @click="add_pre_tax_deduction(i)" class="btn orcaBtn sm_btn grey_bg ml-1"><i class="fas fa-plus mr-2"></i>Pre-Tax Deduction</button>
                    </div>
                  </div>
                </td>
                <td class="deductionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div v-for="(pta, k) in a.deduction_post_tax" class="row ml-0 mr-0">
                    <div class="col-2 pl-0 pr-0 text-center" v-if="!(a.auth_level >= a.contact_job_auth_level)">
                      <button @click="del_post_tax_deduction(i, k)" class="btn orcaBtn sm_btn danger" style="padding: 0 10px;">
                        <i class="fas fa-trash-alt"></i></button>
                    </div>
                    <div :class="[(a.auth_level >= a.contact_job_auth_level) ? 'col-5' : 'col-3', 'pl-0', 'pr-0']">
                      <vue-numeric style="background: transparent;" currency="£" separator="," :precision="2" :minus="false" v-model="pta.amount"
                                   class="timesheet_input" :class="[isDisabled(a)]"
                                   @change="calc_assignment_values(i)" @blur="go_to_details('desc_post_ded_', i, k)"
                                   :disabled="a.auth_level >= a.contact_job_auth_level"></vue-numeric>
                    </div>
                    <div class="col-7 pl-0 pr-0">
                      <multiselect v-model="pta.desc" :id="'desc_post_ded_' + i + '_' + k" :name="'desc_post_ded_' + i + '_' + k" placeholder="" :options="ms_opts.post_ded"
                                   @open="repositionDropdown" label="value"
                                   :disabled="a.auth_level >= a.contact_job_auth_level" :allow-empty="false"
                                   :ref="'desc_post_ded_' + i + '_' + k" @close="close_details('desc_post_ded_', pta, i, k)"
                                   :selectLabel="''"></multiselect>
                    </div>
                  </div>
                  <div v-if="!(a.auth_level >= a.contact_job_auth_level)">
                    <div v-if="a.deduction_post_tax.length > 0">
                      <button v-if="a.deduction_post_tax[a.deduction_post_tax.length - 1].amount !== 0 && a.deduction_post_tax[a.deduction_post_tax.length - 1].desc !== null"
                              @click="add_post_tax_deduction(i)" class="btn orcaBtn sm_btn grey_bg ml-1">
                        <i class="fas fa-plus mr-2"></i>Post-Tax Deduction
                      </button>
                    </div>
                    <div v-else>
                      <button @click="add_post_tax_deduction(i)" class="btn orcaBtn sm_btn grey_bg ml-1"><i class="fas fa-plus mr-2"></i>Post-Tax Deduction</button>
                    </div>
                  </div>
                </td>

                <td class="totalHours">
                  <div class="td_data_outer">
                    <div class="td_data">{{ a.invoice_total | currency }}</div>
                  </div>
                </td>

                <td class="backNextWeek">
                  <div class="td_data_outer">
                    <div class="td_data">
                      <p-check class="p-icon p-smooth" color="success" v-model="a.ts_record.back_next_week"
                               :disabled="a.auth_level >= a.contact_job_auth_level">
                        <i slot="extra" class="icon fa fa-check"></i>
                      </p-check>
                    </div>
                  </div>
                </td>

                <td class="totalHours">
                  <div class="td_data_outer">
                    <!--                    <div class="td_data" v-if="a.auth_level === 0">Worker</div>-->
                    <!--                    <div class="td_data" v-else-if="a.auth_level === a.contact_job_auth_level">-->
                    <!--                      {{a.auth_level}}<br>-->
                    <!--                      {{a.contact_job_auth_level}}<br>-->
                    <!--                      {{a.auth_with}}<br>-->
                    <!--                      <span v-if="crmType === 'payroll'">Genius</span><span v-else-if="crmType === 'recruitment'">V3</span>-->
                    <!--                    </div>-->
                    <div class="td_data" v-if="a.auth_with === 'crm'">
                      <span v-if="crmType === 'payroll'">Genius</span><span v-else-if="crmType === 'recruitment'">V3</span>
                    </div>
                    <div class="td_data" v-else-if="a.auth_with === null">You</div>
                    <div class="td_data" v-else-if="a.auth_with !== null">{{ a.auth_with.first_name }} {{ a.auth_with.surname }}</div>

                  </div>
                </td>

                <td class="submitPayroll">
                  <div class="td_data_outer">
                    <div class="td_data">
                      <p-check v-if="$store.state.auth.me.roles.includes('client_sub')" class="p-icon p-smooth" v-model="a.submit_to_genius"
                               :disabled="a.auth_level >= a.contact_job_auth_level">
                        <i slot="extra" class="icon fa fa-check"></i></p-check>
                      <p-check v-if="$store.state.auth.me.roles.includes('client_auth')" class="p-icon p-smooth" v-model="a.submit_for_auth"
                               :disabled="a.auth_level >= a.contact_job_auth_level">
                        <i slot="extra" class="icon fa fa-check"></i></p-check>
                    </div>
                  </div>
                </td>
              </tr>

              <!--      Running Total for days-->
              <tr class="totals_row">
                <td colspan="2" class="running_totals">
                  <div class="td_data_outer">
                    <div class="td_data bp_color">RUNNING TOTALS</div>
                  </div>
                </td>
                <td class="jobTitle"></td>
                <td class="payRate" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)"></td>
                <td class="payRate"></td>

                <td class="days">
                  <div class="td_data_outer">
                    <div class="td_data">{{ parseFloat(tots.day_1_total).toFixed(2) }}</div>
                  </div>
                </td>
                <td class="days">
                  <div class="td_data_outer">
                    <div class="td_data">{{ parseFloat(tots.day_2_total).toFixed(2) }}</div>
                  </div>
                </td>
                <td class="days">
                  <div class="td_data_outer">
                    <div class="td_data">{{ parseFloat(tots.day_3_total).toFixed(2) }}</div>
                  </div>
                </td>
                <td class="days">
                  <div class="td_data_outer">
                    <div class="td_data">{{ parseFloat(tots.day_4_total).toFixed(2) }}</div>
                  </div>
                </td>
                <td class="days">
                  <div class="td_data_outer">
                    <div class="td_data">{{ parseFloat(tots.day_5_total).toFixed(2) }}</div>
                  </div>
                </td>
                <td class="days">
                  <div class="td_data_outer">
                    <div class="td_data">{{ parseFloat(tots.day_6_total).toFixed(2) }}</div>
                  </div>
                </td>
                <td class="days">
                  <div class="td_data_outer">
                    <div class="td_data">{{ parseFloat(tots.day_7_total).toFixed(2) }}</div>
                  </div>
                </td>

                <td class="hours_invoice"></td>
                <td class="hours_invoice" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)"></td>

                <td class="totalHours">
                  <div class="td_data_outer">
                    <div class="td_data">{{ parseFloat(tots.total_units).toFixed(2) }}</div>
                  </div>
                </td>

                <td class="totalHours" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ tots.total_b4_add_ded | currency }}</div>
                  </div>
                </td>

                <td class="releaseRetention" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)"></td>
                <td class="releaseRetentionAmount" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ tots.retention_total | currency }}</div>
                  </div>
                </td>

                <td class="additionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ tots.pre_tax_add_total | currency }}</div>
                  </div>
                </td>
                <td class="additionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ tots.post_tax_add_total | currency }}</div>
                  </div>
                </td>
                <td class="deductionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ tots.pre_tax_ded_total | currency }}</div>
                  </div>
                </td>
                <td class="deductionsDesc" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
                  <div class="td_data_outer">
                    <div class="td_data">{{ tots.post_tax_ded_total | currency }}</div>
                  </div>
                </td>

                <td class="totalHours">
                  <div class="td_data_outer">
                    <div class="td_data">{{ tots.invoice_total | currency }}</div>
                  </div>
                </td>

                <td class="backNextWeek"></td>

                <td class="totalHours"></td>
<!--                <td class="submitPayroll"></td>-->
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-12">
          <div class="row pl-2 pr-2">
            <div v-if="!check_all_submitted" class="col-xl-6 offset-xl-6">
              <button class="btn orcaBtn mt-2 mb-3" @click.prevent="set_submit_all_workers()">Select all workers ready for
                <span v-if="$store.state.auth.me.roles.includes('client_sub')">submission</span>
                <span v-if="$store.state.auth.me.roles.includes('client_auth')">authorisation</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row ml-0 mr-0 pt-3">
      <div class="col-12">
        <h5 class="text-uppercase mb-2 bp_color" v-if="crmType === 'payroll'">Genius Order Information for this location</h5>
        <h5 class="text-uppercase mb-2 bp_color" v-if="crmType === 'recruitment'">V3 Order Information for this location</h5>
      </div>

      <div class="col-12 mb-3">
        <div class="row ml-0 mr-0" style="background: #fefefe">
          <div class="col-md-9 col-xl-10 mt-2">
            <p class="m-0">Please click the show info button to display all the positions assigned to this location, this will then allow you to fill in information about works
              completed this pay period.</p>
          </div>
          <div class="col-md-3 col-xl-2 mt-2">
            <button class="btn orcaBtn sm_btn mb-3 float-right mt-0" @click="toggle_location_details()">
              <span v-if="!show_location_info">Show Info</span>
              <span v-if="show_location_info">Hide Info</span>
            </button>
          </div>
        </div>
      </div>

      <div v-if="show_location_info" class="col-12">
        <hr>
      </div>
    </div>

    <div v-if="show_location_info" v-for="o_job in order_jobs" class="row ml-0 mr-0">
      <div class="col-md-6">
        <strong><span v-if="crmType === 'payroll'">Genius</span><span v-else-if="crmType === 'recruitment'">V3</span> CCO Ref :</strong> {{ o_job.order_ref }}<br>
        <strong>Job Title:</strong> {{ o_job.rel_order_position.job_title }}
      </div>
      <div class="col-md-6">
        <strong>Supervisor name (Reports to) :</strong> {{ o_job.rel_order_position.reports_to_contact.person.first_name }} {{
          o_job.rel_order_position.reports_to_contact.person.surname
        }}
      </div>
      <div class="col-12 mt-2">
        <div class="row ml-0 mr-0" style="background: #fefefe">
          <div class="col-md-9 col-xl-10 mt-2">
            <p class="mb-0">If you wish to record information for completed works by the {{ o_job.rel_order_position.job_title }}'s working on this site,
              click the 'show&nbsp;info' button to enter/view the details which are broken down by day.</p>
          </div>
          <div class="col-md-3 col-xl-2 mt-2">
            <button class="btn orcaBtn sm_btn mb-3 float-right mt-0" @click="toggle_details(o_job.id)">
              <span v-if="!show_site_info[o_job.id]">Show Info</span>
              <span v-if="show_site_info[o_job.id]">Hide Info</span>
            </button>
          </div>
          <div class="col-12 mt-2" v-if="show_site_info[o_job.id]" v-for="(d, k) in order_job_desc[o_job.id]">
            <div class="row">
              <div class="col-md-3">
                <label :for="'day_desc_' + k" class="cardLabel font-weight-bold">{{ d.label }}</label>
              </div>
              <div class="col-md-9 form-group">
            <textarea class="form-control" :id="'day_desc_' + k" rows="2" :name="'day_desc_' + k"
                      :placeholder="'Add a description of works completed by ' + o_job.rel_order_position.job_title + '\'s'"
                      v-model="d.day_desc" :disabled="check_all_submitted"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <hr class="mt-0 mb-2 mt-2">
      </div>
    </div>

    <!--    <div class="col-12 pl-4 pr-4" v-else>-->
    <!--      <h5 class="text-uppercase red_color">There are no workers assigned to this order</h5>-->
    <!--      <p>If there should be assignments to this order please contact-->
    <!--        <span v-if="crmType === 'payroll'">Genius on <a class="bp_color" href="tel:+443303350400">0330 3350400</a></span>-->
    <!--        <span v-else-if="crmType === 'recruitment'">V3 on <a class="bp_color" href="tel:+442392361115">02392 361115</a></span>-->
    <!--        .</p>-->
    <!--    </div>-->
  </div>
</template>

<script>
import VueNumeric from 'components/plugins/vue-numeric';
import PrettyCheckbox from 'pretty-checkbox-vue';
import Multiselect from 'vue-multiselect';
import Vue from "vue";

Vue.use(PrettyCheckbox);

export default {
  name: "submit_table",
  props: ['week', 'order_index', 'save_for_later', 'ts_records', 'order_jobs', 'totals',
    'submit_auth_genius', 'company_name', 'submit_all_workers', 'authorise_all_workers', 'trigger',
    'ms_opts_pre_add', 'ms_opts_post_add', 'ms_opts_pre_ded', 'ms_opts_post_ded'],
  components: {
    VueNumeric,
    Multiselect
  },
  data() {
    return {
      isTouched: true,

      recs: this.ts_records,
      tots: this.totals,

      ms_opts: {
        pre_add: this.ms_opts_pre_add,
        post_add: this.ms_opts_post_add,
        pre_ded: this.ms_opts_pre_ded,
        post_ded: this.ms_opts_post_ded
      },

      order_job_desc: {},
      show_location_info: false,
      show_site_info: {},
    }
  },
  beforeMount() {
    for (let i = 0; i < this.order_jobs.length; i++) {
      this.order_job_desc[this.order_jobs[i].id] = [];
      Vue.set(this.show_site_info, this.order_jobs[i].id, false)

      if (this.order_jobs[i].timesheet_info.length !== 0) {
        for (const [key, value] of Object.entries(this.order_jobs[i].timesheet_info)) {
          let temp_order_job_desc = value;
          temp_order_job_desc['label'] = this.$moment.utc(temp_order_job_desc.pay_date).format('dddd') + ' ' +
              this.$moment.utc(temp_order_job_desc.pay_date).format('DD/MM/YYYY');
          temp_order_job_desc['log_by_type'] = 'App\\Models\\Users\\User';
          temp_order_job_desc['log_by_id'] = this.$store.state.auth.me.id;

          this.order_job_desc[value.order_job_id].push(temp_order_job_desc)
        }
      }
      else {
        for (const [key, value] of Object.entries(this.week)) {
          this.order_job_desc[this.order_jobs[i].id].push({
            'order_job_id': this.order_jobs[i].id,
            'label': value,
            'for_work_end_week_date': this.$moment.utc(this.week[6].split(' ')[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            'pay_date': this.$moment.utc(value.split(' ')[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            'day_desc': null,
            'log_by_type': 'App\\Models\\Users\\User',
            'log_by_id': this.$store.state.auth.me.id
          });
        }
      }
    }
  },
  mounted() {
    // axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_additions').then(res => this.ms_opts.pre_add = res.data);
    // axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_additions').then(res => this.ms_opts.post_add = res.data);
    // axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_deductions').then(res => this.ms_opts.pre_ded = res.data);
    // axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_deductions').then(res => this.ms_opts.post_ded = res.data);

    if (this.notEmptyObject(this.recs)) {
      for (let i = 0; i < this.recs.length; i++) {
        this.calc_assignment_values(i)
      }
      // this.calc_totals();
    }
  },
  computed: {
    calc_left_submit() {
      if (this.$store.state.auth.me.roles.includes('client_sub')) {
        let submitted = Object.values(this.ts_records).filter(a => a.submit_to_genius === true);
        return Object.keys(submitted).length + ' / ' + Object.keys(this.recs).length
      }
      else if (this.$store.state.auth.me.roles.includes('client_auth')) {
        let authed = Object.values(this.ts_records).filter(a => a.submit_for_auth === true);
        return Object.keys(authed).length + ' / ' + Object.keys(this.recs).length
      }
    },
    check_all_submitted() {
      if (this.$store.state.auth.me.roles.includes('client_sub')) {
        let submitted = Object.values(this.ts_records).filter(a => a.submit_to_genius === true);
        return Object.keys(submitted).length === Object.keys(this.recs).length;
      }
      else if (this.$store.state.auth.me.roles.includes('client_auth')) {
        let authed = Object.values(this.ts_records).filter(a => a.submit_for_auth === true);
        return Object.keys(authed).length === Object.keys(this.recs).length;
      }
    }
  },
  methods: {
    set_submit_all_workers() {
      for (const [key, value] of Object.entries(this.recs)) {
        if (this.$store.state.auth.me.roles.includes('client_sub')) {
          value.submit_to_genius = true;
        }
        else if (this.$store.state.auth.me.roles.includes('client_auth')) {
          value.submit_for_auth = true;
        }
      }
    },

    repositionDropdown(id) {
      const el = document.getElementById(id);
      const parent = el.closest('.multiselect');
      const content = parent.querySelector('.multiselect__content-wrapper');
      const {top, height, left} = parent.getBoundingClientRect();

      content.style.width = `${parent.clientWidth + 20}px`;
      content.style.position = 'absolute';
      content.style.bottom = 'auto';
      // content.style.top = `${top + height}px`;
      // content.style.left = `${left}px`;
    },

    go_to_details(type, i, k) {
      this.$refs[type + i + '_' + k][0].activate()
    },

    close_details(type, val, i, k) {
      // if no value then show alert and then re-open select (and select still exists)
      this.$nextTick(() => {
        if (val.desc === null && this.$refs[type + i + '_' + k].length > 0) {
          this.go_to_details(type, i, k)
        }
      })
    },

    isDisabled(row_auth_level) {
      if (row_auth_level.auth_level >= row_auth_level.contact_job_auth_level) {
        return 'disabled'
      }
      else {
        return ''
      }
    },
    calc_assignment_values(worker_index) {
      // console.log('ass_val: ' + worker_index)
      this.calc_worker_total_day_units(worker_index);
      this.calc_worker_total_before_additions_deductions(worker_index);
      this.calc_retention(worker_index);
      this.calc_invoice_total(worker_index);

      this.calc_totals();
      // trigger calculation of preview rows (timesheet preview table)
      this.$parent.$parent.calc_preview_rows();
    },

    show_hours(hours, first_name, surname) {
      this.$store.commit('SHOW_HOURS_MODAL', {
        first_name: first_name,
        surname: surname,
        hours: hours
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'show_hours_modal'));
    },
    show_invoice(invoice, first_name, surname) {
      this.$store.commit('SHOW_INVOICE_MODAL', {
        first_name: first_name,
        surname: surname,
        invoice: invoice
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'show_invoice_modal'));
    },

    calc_worker_total_day_units(worker_index) {
      let total = 0, day_1 = 0, day_2 = 0, day_3 = 0, day_4 = 0, day_5 = 0, day_6 = 0, day_7 = 0;

      day_1 = parseFloat(this.recs[worker_index].timesheet_pay[0].price);
      day_2 = parseFloat(this.recs[worker_index].timesheet_pay[1].price);
      day_3 = parseFloat(this.recs[worker_index].timesheet_pay[2].price);
      day_4 = parseFloat(this.recs[worker_index].timesheet_pay[3].price);
      day_5 = parseFloat(this.recs[worker_index].timesheet_pay[4].price);
      day_6 = parseFloat(this.recs[worker_index].timesheet_pay[5].price);
      day_7 = parseFloat(this.recs[worker_index].timesheet_pay[6].price);

      total = (day_1 + day_2 + day_3 + day_4 + day_5 + day_6 + day_7);
      Vue.set(this.recs[worker_index], 'total_units', total);
      Vue.set(this.recs[worker_index]['ts_record'], 'total_hours', total);
    },

    calc_worker_total_before_additions_deductions(worker_index) {
      let total = 0;
      let day_1 = 0, day_2 = 0, day_3 = 0, day_4 = 0, day_5 = 0, day_6 = 0, day_7 = 0;
      day_1 = parseFloat(this.recs[worker_index].timesheet_pay[0].price);
      day_2 = parseFloat(this.recs[worker_index].timesheet_pay[1].price);
      day_3 = parseFloat(this.recs[worker_index].timesheet_pay[2].price);
      day_4 = parseFloat(this.recs[worker_index].timesheet_pay[3].price);
      day_5 = parseFloat(this.recs[worker_index].timesheet_pay[4].price);
      day_6 = parseFloat(this.recs[worker_index].timesheet_pay[5].price);
      day_7 = parseFloat(this.recs[worker_index].timesheet_pay[6].price);
      total = parseFloat(this.recs[worker_index].pay_rate) * (day_1 + day_2 + day_3 + day_4 + day_5 + day_6 + day_7);
      Vue.set(this.recs[worker_index], 'total_before_additions_deductions', total);
      Vue.set(this.recs[worker_index]['ts_record'], 'total_price', total);
    },

    calc_retention(worker_index) {
      if (this.recs[worker_index].total_before_additions_deductions !== 0 && !this.recs[worker_index].retention_released) {
        this.recs[worker_index].retention_amount = parseFloat(this.recs[worker_index].total_before_additions_deductions) *
            (parseFloat(this.recs[worker_index].retention_percentage) / 100);
      }
      else {
        this.recs[worker_index].retention_amount = 0;
      }
    },

    calc_invoice_total(worker_index) {
      let total = 0;
      if (this.recs[worker_index].total_before_additions_deductions !== 0) {
        total += parseFloat(this.recs[worker_index].total_before_additions_deductions);
      }

      let add_pre_tax = 0;
      if (this.recs[worker_index].addition_pre_tax.length > 0) {
        for (let i = 0; i < this.recs[worker_index].addition_pre_tax.length; i++) {
          add_pre_tax += parseFloat(this.recs[worker_index].addition_pre_tax[i].amount);
        }
      }
      let add_post_tax = 0;
      if (this.recs[worker_index].addition_post_tax.length > 0) {
        for (let i = 0; i < this.recs[worker_index].addition_post_tax.length; i++) {
          add_post_tax += parseFloat(this.recs[worker_index].addition_post_tax[i].amount);
        }
      }
      let ded_pre_tax = 0;
      if (this.recs[worker_index].deduction_pre_tax.length > 0) {
        for (let i = 0; i < this.recs[worker_index].deduction_pre_tax.length; i++) {
          ded_pre_tax += parseFloat(this.recs[worker_index].deduction_pre_tax[i].amount);
        }
      }
      let ded_post_tax = 0;
      if (this.recs[worker_index].deduction_post_tax.length > 0) {
        for (let i = 0; i < this.recs[worker_index].deduction_post_tax.length; i++) {
          ded_post_tax += parseFloat(this.recs[worker_index].deduction_post_tax[i].amount);
        }
      }

      total = total + add_pre_tax + add_post_tax - ded_pre_tax - ded_post_tax;
      Vue.set(this.recs[worker_index], 'invoice_total', total);
      Vue.set(this.recs[worker_index]['ts_record'], 'total_pay_amount', total);
    },

    add_pre_tax_addition(worker_index) {
      let temp = this.recs[worker_index].addition_pre_tax;
      temp.push({amount: 0, desc: null});
      Vue.set(this.recs[worker_index], 'addition_pre_tax', temp);
      Vue.set(this.recs[worker_index]['ts_record'], 'timesheet_additions_deductions', temp);
    },
    del_pre_tax_addition(worker_index, addition_index) {
      let desc = '';
      if (this.recs[worker_index].addition_pre_tax[addition_index].desc !== null) {
        desc = this.recs[worker_index].addition_pre_tax[addition_index].desc.value
      }
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Pre-Tax Addition</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to remove the following Pre-Tax Addition:<br><br>' +
            '<strong class="text-uppercase" style="font-size: 1rem;">' + this.recs[worker_index].first_name + ' ' + this.recs[worker_index].surname + '</strong>' +
            '<br><br>' +
            '<strong class="d-inline-block" style="width: 90px;">Amount:</strong>' + this.$options.filters.currency(this.recs[worker_index].addition_pre_tax[addition_index].amount) +
            '<br>' +
            '<strong class="d-inline-block" style="width: 90px;">Description:</strong>' + desc + '<br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Ok', action: (toast) => {
              if ('ts_record_id' in this.recs[worker_index].addition_pre_tax[addition_index]) {
                axios.delete(this.crmApiPath + 'timesheet/additions_deductions/' + this.recs[worker_index].addition_pre_tax[addition_index].id, {
                  params: {
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => {
                  this.$snotify.remove(toast.id);
                  this.recs[worker_index].addition_pre_tax.splice(addition_index, 1);
                  this.calc_assignment_values(worker_index);
                })
              }
              else {
                this.$snotify.remove(toast.id);
                this.recs[worker_index].addition_pre_tax.splice(addition_index, 1);
                this.calc_assignment_values(worker_index);
              }
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },
    add_post_tax_addition(worker_index) {
      let temp = this.recs[worker_index].addition_post_tax;
      temp.push({amount: 0, desc: null});
      Vue.set(this.recs[worker_index], 'addition_post_tax', temp);
      Vue.set(this.recs[worker_index]['ts_record'], 'timesheet_additions_deductions', temp);
    },
    del_post_tax_addition(worker_index, addition_index) {
      let desc = '';
      if (this.recs[worker_index].addition_post_tax[addition_index].desc !== null) {
        desc = this.recs[worker_index].addition_post_tax[addition_index].desc.value
      }
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Post-Tax Addition</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to remove the following Post-Tax Addition:<br><br>' +
            '<strong class="text-uppercase" style="font-size: 1rem;">' + this.recs[worker_index].first_name + ' ' + this.recs[worker_index].surname + '</strong>' +
            '<br><br>' +
            '<strong class="d-inline-block" style="width: 90px;">Amount:</strong>' + this.$options.filters.currency(this.recs[worker_index].addition_post_tax[addition_index].amount) +
            '<br>' +
            '<strong class="d-inline-block" style="width: 90px;">Description:</strong>' + desc + '<br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Ok', action: (toast) => {
              if ('ts_record_id' in this.recs[worker_index].addition_post_tax[addition_index]) {
                axios.delete(this.crmApiPath + 'timesheet/additions_deductions/' + this.recs[worker_index].addition_post_tax[addition_index].id, {
                  params: {
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => {
                  this.$snotify.remove(toast.id);
                  this.recs[worker_index].addition_post_tax.splice(addition_index, 1);
                  this.calc_assignment_values(worker_index);
                })
              }
              else {
                this.$snotify.remove(toast.id);
                this.recs[worker_index].addition_post_tax.splice(addition_index, 1);
                this.calc_assignment_values(worker_index);
              }
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },
    add_pre_tax_deduction(worker_index) {
      let temp = this.recs[worker_index].deduction_pre_tax;
      temp.push({amount: 0, desc: null});
      Vue.set(this.recs[worker_index], 'deduction_pre_tax', temp);
      Vue.set(this.recs[worker_index]['ts_record'], 'timesheet_additions_deductions', temp);
    },
    del_pre_tax_deduction(worker_index, deduction_index) {
      let desc = '';
      if (this.recs[worker_index].deduction_pre_tax[deduction_index].desc !== null) {
        desc = this.recs[worker_index].deduction_pre_tax[deduction_index].desc.value
      }
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Pre-Tax Deduction</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to remove the following Pre-Tax Deduction:<br><br>' +
            '<strong class="text-uppercase" style="font-size: 1rem;">' + this.recs[worker_index].first_name + ' ' + this.recs[worker_index].surname + '</strong>' +
            '<br><br>' +
            '<strong class="d-inline-block" style="width: 90px;">Amount:</strong>' + this.$options.filters.currency(this.recs[worker_index].deduction_pre_tax[deduction_index].amount) +
            '<br>' +
            '<strong class="d-inline-block" style="width: 90px;">Description:</strong>' + desc + '<br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-t1riangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Ok', action: (toast) => {
              if ('ts_record_id' in this.recs[worker_index].deduction_pre_tax[deduction_index]) {
                axios.delete(this.crmApiPath + 'timesheet/additions_deductions/' + this.recs[worker_index].deduction_pre_tax[deduction_index].id, {
                  params: {
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => {
                  this.$snotify.remove(toast.id);
                  this.recs[worker_index].deduction_pre_tax.splice(deduction_index, 1);
                  this.calc_assignment_values(worker_index);
                })
              }
              else {
                this.$snotify.remove(toast.id);
                this.recs[worker_index].deduction_pre_tax.splice(deduction_index, 1);
                this.calc_assignment_values(worker_index);
              }
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },
    add_post_tax_deduction(worker_index) {
      let temp = this.recs[worker_index].deduction_post_tax;
      temp.push({amount: 0, desc: null});
      Vue.set(this.recs[worker_index], 'deduction_post_tax', temp);
      Vue.set(this.recs[worker_index]['ts_record'], 'timesheet_additions_deductions', temp);
    },
    del_post_tax_deduction(worker_index, deduction_index) {
      let desc = '';
      if (this.recs[worker_index].deduction_post_tax[deduction_index].desc !== null) {
        desc = this.recs[worker_index].deduction_post_tax[deduction_index].desc.value
      }
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Post-Tax Deduction</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to remove the following Post-Tax Deduction:<br><br>' +
            '<strong class="text-uppercase" style="font-size: 1rem;">' + this.recs[worker_index].first_name + ' ' + this.recs[worker_index].surname + '</strong>' +
            '<br><br>' +
            '<strong class="d-inline-block" style="width: 90px;">Amount:</strong>' + this.$options.filters.currency(this.recs[worker_index].deduction_post_tax[deduction_index].amount) +
            '<br>' +
            '<strong class="d-inline-block" style="width: 90px;">Description:</strong>' + desc + '<br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Ok', action: (toast) => {
              if ('ts_record_id' in this.recs[worker_index].deduction_post_tax[deduction_index]) {
                axios.delete(this.crmApiPath + 'timesheet/additions_deductions/' + this.recs[worker_index].deduction_post_tax[deduction_index].id, {
                  params: {
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => {
                  this.$snotify.remove(toast.id);
                  this.recs[worker_index].deduction_post_tax.splice(deduction_index, 1);
                  this.calc_assignment_values(worker_index);
                })
              }
              else {
                this.$snotify.remove(toast.id);
                this.recs[worker_index].deduction_post_tax.splice(deduction_index, 1);
                this.calc_assignment_values(worker_index);
              }
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },

    calc_totals() {
      let day_1_tot = 0, day_1_all_tot = 0,
          day_2_tot = 0, day_2_all_tot = 0,
          day_3_tot = 0, day_3_all_tot = 0,
          day_4_tot = 0, day_4_all_tot = 0,
          day_5_tot = 0, day_5_all_tot = 0,
          day_6_tot = 0, day_6_all_tot = 0,
          day_7_tot = 0, day_7_all_tot = 0,
          tot_units = 0, tot_b4_add_ded = 0, ret_tot = 0,
          pre_tax_add_tot = 0, post_tax_add_tot = 0, pre_tax_ded_tot = 0, post_tax_ded_tot = 0,
          inv_tot = 0;

      for (let a in this.recs) {
        day_1_tot = parseFloat(this.recs[a].timesheet_pay[0].price);
        day_1_all_tot += parseFloat(this.recs[a].timesheet_pay[0].price);
        day_2_tot = parseFloat(this.recs[a].timesheet_pay[1].price);
        day_2_all_tot += parseFloat(this.recs[a].timesheet_pay[1].price);
        day_3_tot = parseFloat(this.recs[a].timesheet_pay[2].price);
        day_3_all_tot += parseFloat(this.recs[a].timesheet_pay[2].price);
        day_4_tot = parseFloat(this.recs[a].timesheet_pay[3].price);
        day_4_all_tot += parseFloat(this.recs[a].timesheet_pay[3].price);
        day_5_tot = parseFloat(this.recs[a].timesheet_pay[4].price);
        day_5_all_tot += parseFloat(this.recs[a].timesheet_pay[4].price);
        day_6_tot = parseFloat(this.recs[a].timesheet_pay[5].price);
        day_6_all_tot += parseFloat(this.recs[a].timesheet_pay[5].price);
        day_7_tot = parseFloat(this.recs[a].timesheet_pay[6].price);
        day_7_all_tot += parseFloat(this.recs[a].timesheet_pay[6].price);

        tot_units += (day_1_tot + day_2_tot + day_3_tot + day_4_tot + day_5_tot + day_6_tot + day_7_tot);
        tot_b4_add_ded += parseFloat(this.recs[a].total_before_additions_deductions);
        ret_tot += parseFloat(this.recs[a].retention_amount);

        if (this.recs[a].addition_pre_tax.length > 0) {
          for (let i = 0; i < this.recs[a].addition_pre_tax.length; i++) {
            pre_tax_add_tot += parseFloat(this.recs[a].addition_pre_tax[i].amount);
          }
        }
        if (this.recs[a].addition_post_tax.length > 0) {
          for (let i = 0; i < this.recs[a].addition_post_tax.length; i++) {
            post_tax_add_tot += parseFloat(this.recs[a].addition_post_tax[i].amount);
          }
        }
        if (this.recs[a].deduction_pre_tax.length > 0) {
          for (let i = 0; i < this.recs[a].deduction_pre_tax.length; i++) {
            pre_tax_ded_tot += parseFloat(this.recs[a].deduction_pre_tax[i].amount);
          }
        }
        if (this.recs[a].deduction_post_tax.length > 0) {
          for (let i = 0; i < this.recs[a].deduction_post_tax.length; i++) {
            post_tax_ded_tot += parseFloat(this.recs[a].deduction_post_tax[i].amount);
          }
        }
        inv_tot += parseFloat(this.recs[a].invoice_total);
      }

      Vue.set(this.tots, 'day_1_total', day_1_all_tot);
      Vue.set(this.tots, 'day_2_total', day_2_all_tot);
      Vue.set(this.tots, 'day_3_total', day_3_all_tot);
      Vue.set(this.tots, 'day_4_total', day_4_all_tot);
      Vue.set(this.tots, 'day_5_total', day_5_all_tot);
      Vue.set(this.tots, 'day_6_total', day_6_all_tot);
      Vue.set(this.tots, 'day_7_total', day_7_all_tot);
      // Vue.set(this.tots, 'fixed_total', fixed_tot);
      Vue.set(this.tots, 'total_units', tot_units);
      Vue.set(this.tots, 'total_b4_add_ded', tot_b4_add_ded);
      Vue.set(this.tots, 'retention_total', ret_tot);
      Vue.set(this.tots, 'pre_tax_add_total', pre_tax_add_tot);
      Vue.set(this.tots, 'post_tax_add_total', post_tax_add_tot);
      Vue.set(this.tots, 'pre_tax_ded_total', pre_tax_ded_tot);
      Vue.set(this.tots, 'post_tax_ded_total', post_tax_ded_tot);
      Vue.set(this.tots, 'invoice_total', inv_tot);

      // console.log('calc_values')
    },

    toggle_location_details() {
      this.show_location_info = !this.show_location_info;
    },
    toggle_details(order_job_id) {
      this.show_site_info[order_job_id] = !this.show_site_info[order_job_id];
    }
  },
  watch: {
    trigger(val) {
      if (val) {
        this.recs = this.ts_records
        this.order_job_desc = {};
        for (let i = 0; i < this.order_jobs.length; i++) {
          this.order_job_desc[this.order_jobs[i].id] = [];
          if (this.order_jobs[i].timesheet_info.length !== 0) {
            for (const [key, value] of Object.entries(this.order_jobs[i].timesheet_info)) {
              let temp_order_job_desc = value;
              temp_order_job_desc['label'] = this.$moment.utc(temp_order_job_desc.pay_date).format('dddd') + ' ' +
                  this.$moment.utc(temp_order_job_desc.pay_date).format('DD/MM/YYYY');
              temp_order_job_desc['log_by_type'] = 'App\\Models\\Users\\User';
              temp_order_job_desc['log_by_id'] = this.$store.state.auth.me.id;
              this.order_job_desc[value.order_job_id].push(temp_order_job_desc)
            }
          }
        }
        this.$emit('trigger_reset', this.order_index)
      }
    },
    save_for_later(val) {
      if (val === this.order_index) {
        new Promise(resolve => {
          let count = 0;
          let t_axios = {'ass': [], 'o_desc': []};
          let o_desc = {patch: [], post: []};
          for (const [key, value] of Object.entries(this.order_job_desc)) {
            for (const [k, v] of Object.entries(value)) {
              if (v.hasOwnProperty('id')) {
                o_desc.patch.push(v)
              }
              else {
                o_desc.post.push(v)
              }
            }
          }
          t_axios.o_desc = o_desc;

          for (let a in this.recs) {
            if (this.recs[a].auth_level < this.order_jobs.find(o => o.id === this.recs[a].order_job_id).auth_level) {
              let t_record = {
                't_record_id': this.recs[a].ts_record.id,
                'worker_first_name': this.recs[a].first_name,
                'worker_surname': this.recs[a].surname,
                'worker_id': this.recs[a].ts_record.worker_id,
                'assignment_id': this.recs[a].ts_record.assignment_id,
                'order_job_id': this.recs[a].order_job_id,
                'company_id': this.recs[a].ts_record.company_id,
                'pay_period_week': this.recs[a].ts_record.pay_period_week,
                'pay_period_year': this.recs[a].ts_record.pay_period_year,
                'for_work_end_week_date': this.recs[a].ts_record.for_work_end_week_date,

                'total_hours': this.recs[a].total_units,
                'total_price': this.recs[a].total_before_additions_deductions,
                'total_pay_amount': this.recs[a].invoice_total,
                'retention_released': this.recs[a].retention_released,
                'retention_amount': this.recs[a].retention_amount,
                'back_next_week': this.recs[a].back_next_week,

                'auth_level': this.recs[a].auth_level,
                'company_submitted': this.recs[a].submit_to_genius,

                // Set log values (current crm user)
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id
              };
              let t_pay = [];
              let ts_rec_id = null;
              for (let p in this.recs[a].timesheet_pay) {
                ts_rec_id = this.recs[a].timesheet_pay[p].ts_record_id;
                t_pay.push({
                  't_pay_id': this.recs[a].timesheet_pay[p].id,
                  'ts_record_id': this.recs[a].timesheet_pay[p].ts_record_id,
                  'pay_date': this.recs[a].timesheet_pay[p].pay_date,
                  'hours_total': this.recs[a].timesheet_pay[p].hours_total,
                  'price': this.recs[a].timesheet_pay[p].price,
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                });
              }
              // PRE Tax Addition
              let pre_tax_add = {
                patch: [],
                post: []
              }
              this.recs[a].addition_pre_tax = this.ts_records[a].addition_pre_tax
              // console.log(this.recs[a].addition_pre_tax)
              for (let i = 0; i < this.recs[a].addition_pre_tax.length; i++) {
                if (this.recs[a].addition_pre_tax[i].desc !== null) {
                  if ("ts_record_id" in this.recs[a].addition_pre_tax[i]) {
                    pre_tax_add.patch.push({
                      't_pre_tax_add_id': this.recs[a].addition_pre_tax[i].id,
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].addition_pre_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].addition_pre_tax[i].desc.id,
                      'amount': this.recs[a].addition_pre_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                  else {
                    pre_tax_add.post.push({
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].addition_pre_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].addition_pre_tax[i].desc.id,
                      'amount': this.recs[a].addition_pre_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                }
              }
              // POST Tax Addition
              let post_tax_add = {
                patch: [],
                post: []
              }
              this.recs[a].addition_post_tax = this.ts_records[a].addition_post_tax
              for (let i = 0; i < this.recs[a].addition_post_tax.length; i++) {
                if (this.recs[a].addition_post_tax[i].desc !== null) {
                  if ("ts_record_id" in this.recs[a].addition_post_tax[i]) {
                    post_tax_add.patch.push({
                      't_post_tax_add_id': this.recs[a].addition_post_tax[i].id,
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].addition_post_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].addition_post_tax[i].desc.id,
                      'amount': this.recs[a].addition_post_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                  else {
                    post_tax_add.post.push({
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].addition_post_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].addition_post_tax[i].desc.id,
                      'amount': this.recs[a].addition_post_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                }
              }
              // PRE Tax Deduction
              let pre_tax_ded = {
                patch: [],
                post: []
              }
              this.recs[a].deduction_pre_tax = this.ts_records[a].deduction_pre_tax
              for (let i = 0; i < this.recs[a].deduction_pre_tax.length; i++) {
                if (this.recs[a].deduction_pre_tax[i].desc !== null) {
                  if ("ts_record_id" in this.recs[a].deduction_pre_tax[i]) {
                    pre_tax_ded.patch.push({
                      't_pre_tax_ded_id': this.recs[a].deduction_pre_tax[i].id,
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].deduction_pre_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].deduction_pre_tax[i].desc.id,
                      'amount': this.recs[a].deduction_pre_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                  else {
                    pre_tax_ded.post.push({
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].deduction_pre_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].deduction_pre_tax[i].desc.id,
                      'amount': this.recs[a].deduction_pre_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                }
              }
              // POST Tax Deduction
              let post_tax_ded = {
                patch: [],
                post: []
              }
              this.recs[a].deduction_post_tax = this.ts_records[a].deduction_post_tax
              for (let i = 0; i < this.recs[a].deduction_post_tax.length; i++) {
                if (this.recs[a].deduction_post_tax[i].desc !== null) {
                  if ("ts_record_id" in this.recs[a].deduction_post_tax[i]) {
                    post_tax_ded.patch.push({
                      't_post_tax_ded_id': this.recs[a].deduction_post_tax[i].id,
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].deduction_post_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].deduction_post_tax[i].desc.id,
                      'amount': this.recs[a].deduction_post_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                  else {
                    post_tax_ded.post.push({
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].deduction_post_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].deduction_post_tax[i].desc.id,
                      'amount': this.recs[a].deduction_post_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                }
              }

              t_axios.ass.push({
                't_record': t_record,
                't_o_desc': o_desc,
                't_pay': t_pay,
                'pre_tax_add': pre_tax_add,
                'post_tax_add': post_tax_add,
                'pre_tax_ded': pre_tax_ded,
                'post_tax_ded': post_tax_ded
              })
            }
            count++;
            if (Object.keys(this.recs).length === count) {
              // console.log(t_axios)
              axios.post(this.crmApiPath + 'timesheet/save_for_later', t_axios).then(res => {
                // console.log(this.ts_records)
                resolve()
              })
            }
          }

        }).then(() => {
          setTimeout(() => {
            this.$emit("change_save_for_later", this.order_index);
            this.$emit("increment_save_for_later", this.order_index + 1);
          }, 2000);
        })
      }
    },
    submit_auth_genius(val) {
      if (val === this.order_index) {
        new Promise(resolve => {
          let count = 0;
          let t_axios = {
            'ass': [],
            'o_desc': []
          };
          let o_desc = {
            patch: [],
            post: []
          };

          for (const [key, value] of Object.entries(this.order_job_desc)) {
            for (const [k, v] of Object.entries(value)) {
              if (v.hasOwnProperty('id')) {
                o_desc.patch.push(v)
              }
              else {
                o_desc.post.push(v)
              }
            }
          }

          t_axios.o_desc = o_desc;
          for (let a in this.recs) {
            if (this.recs[a].auth_level < this.order_jobs.find(o => o.id === this.recs[a].order_job_id).auth_level) {
              let t_record = {
                't_record_id': this.recs[a].ts_record.id,
                'worker_first_name': this.recs[a].first_name,
                'worker_surname': this.recs[a].surname,
                'worker_id': this.recs[a].ts_record.worker_id,
                'internal_finance_ref': this.recs[a].internal_finance_ref,
                'assignment_id': this.recs[a].ts_record.assignment_id,
                'order_job_id': this.recs[a].order_job_id,
                'company_id': this.recs[a].ts_record.company_id,
                'pay_period_week': this.recs[a].ts_record.pay_period_week,
                'pay_period_year': this.recs[a].ts_record.pay_period_year,
                'for_work_end_week_date': this.recs[a].ts_record.for_work_end_week_date,

                'total_hours': this.recs[a].total_units,
                'total_price': this.recs[a].total_before_additions_deductions,
                'total_pay_amount': this.recs[a].invoice_total,
                'retention_released': this.recs[a].ts_record.retention_released,
                'retention_amount': this.recs[a].ts_record.retention_amount,
                'back_next_week': this.recs[a].ts_record.back_next_week,

                // Set log values (current crm user)
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id
              };
              if (this.recs[a].submit_to_genius) {
                t_record['auth_level'] = this.order_jobs.find(o => o.id === this.recs[a].order_job_id).auth_level;
                t_record['company_submitted'] = true;
                t_record['check_submitted'] = true;
              }
              else if (this.recs[a].submit_for_auth) {
                t_record['auth_level'] = this.order_jobs.find(o => o.id === this.recs[a].order_job_id).auth_level;
              }
              else {
                t_record['auth_level'] = this.recs[a].auth_level;
              }
              let t_pay = [];
              let ts_rec_id = null;
              for (let p in this.recs[a].ts_record.timesheet_pay) {
                ts_rec_id = this.recs[a].ts_record.timesheet_pay[p].ts_record_id;
                t_pay.push({
                  't_pay_id': this.recs[a].ts_record.timesheet_pay[p].id,
                  'ts_record_id': this.recs[a].ts_record.timesheet_pay[p].ts_record_id,
                  'pay_date': this.recs[a].ts_record.timesheet_pay[p].pay_date,
                  'hours_total': this.recs[a].ts_record.timesheet_pay[p].hours_total,
                  'price': this.recs[a].ts_record.timesheet_pay[p].price,
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                });
              }
              // PRE Tax Addition
              let pre_tax_add = {
                patch: [],
                post: []
              }
              this.recs[a].addition_pre_tax = this.ts_records[a].addition_pre_tax
              for (let i = 0; i < this.recs[a].addition_pre_tax.length; i++) {
                if (this.recs[a].addition_pre_tax[i].desc !== null) {
                  if ("ts_record_id" in this.recs[a].addition_pre_tax[i]) {
                    pre_tax_add.patch.push({
                      't_pre_tax_add_id': this.recs[a].addition_pre_tax[i].id,
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].addition_pre_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].addition_pre_tax[i].desc.id,
                      'amount': this.recs[a].addition_pre_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                  else {
                    pre_tax_add.post.push({
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].addition_pre_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].addition_pre_tax[i].desc.id,
                      'amount': this.recs[a].addition_pre_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                }
              }
              // POST Tax Addition
              let post_tax_add = {
                patch: [],
                post: []
              }
              this.recs[a].addition_post_tax = this.ts_records[a].addition_post_tax
              for (let i = 0; i < this.recs[a].addition_post_tax.length; i++) {
                if (this.recs[a].addition_post_tax[i].desc !== null) {
                  if ("ts_record_id" in this.recs[a].addition_post_tax[i]) {
                    post_tax_add.patch.push({
                      't_post_tax_add_id': this.recs[a].addition_post_tax[i].id,
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].addition_post_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].addition_post_tax[i].desc.id,
                      'amount': this.recs[a].addition_post_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                  else {
                    post_tax_add.post.push({
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].addition_post_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].addition_post_tax[i].desc.id,
                      'amount': this.recs[a].addition_post_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                }

              }
              // PRE Tax Deduction
              let pre_tax_ded = {
                patch: [],
                post: []
              }
              this.recs[a].deduction_pre_tax = this.ts_records[a].deduction_pre_tax
              for (let i = 0; i < this.recs[a].deduction_pre_tax.length; i++) {
                if (this.recs[a].deduction_pre_tax[i].desc !== null) {
                  if ("ts_record_id" in this.recs[a].deduction_pre_tax[i]) {
                    pre_tax_ded.patch.push({
                      't_pre_tax_ded_id': this.recs[a].deduction_pre_tax[i].id,
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].deduction_pre_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].deduction_pre_tax[i].desc.id,
                      'amount': this.recs[a].deduction_pre_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                  else {
                    pre_tax_ded.post.push({
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].deduction_pre_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].deduction_pre_tax[i].desc.id,
                      'amount': this.recs[a].deduction_pre_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                }

              }
              // POST Tax Deduction
              let post_tax_ded = {
                patch: [],
                post: []
              }
              this.recs[a].deduction_post_tax = this.ts_records[a].deduction_post_tax
              for (let i = 0; i < this.recs[a].deduction_post_tax.length; i++) {
                if (this.recs[a].deduction_post_tax[i].desc !== null) {
                  if ("ts_record_id" in this.recs[a].deduction_post_tax[i]) {
                    post_tax_ded.patch.push({
                      't_post_tax_ded_id': this.recs[a].deduction_post_tax[i].id,
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].deduction_post_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].deduction_post_tax[i].desc.id,
                      'amount': this.recs[a].deduction_post_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                  else {
                    post_tax_ded.post.push({
                      'ts_record_id': ts_rec_id,
                      'add_ded_type_id': this.recs[a].deduction_post_tax[i].desc.crm_attribute_master_type_id,
                      'add_ded_desc_id': this.recs[a].deduction_post_tax[i].desc.id,
                      'amount': this.recs[a].deduction_post_tax[i].amount,
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    })
                  }
                }

              }

              t_axios.ass.push({
                'company': {
                  'name': this.company_name,
                  'me': this.$store.state.auth.me,
                  'submission_level': this.order_jobs.find(o => o.id === this.recs[a].order_job_id).auth_level,
                  'auth': this.$store.state.auth.me.roles.includes('client_auth'),
                  'sub': this.$store.state.auth.me.roles.includes('client_sub'),
                  'order_ref': this.order_jobs.find(o => o.id === this.recs[a].order_job_id).order_ref
                },
                't_record': t_record,
                't_pay': t_pay,
                'pre_tax_add': pre_tax_add,
                'post_tax_add': post_tax_add,
                'pre_tax_ded': pre_tax_ded,
                'post_tax_ded': post_tax_ded
              })
            }

            count++;
            // console.log('ass length:' + Object.keys(this.recs).length)
            // console.log('count:' + count)
            if (Object.keys(this.recs).length === count) {
              axios.post(this.crmApiPath + 'timesheet/save_submit', t_axios).then((res) => {
                // this.$emit("change_submit_auth_genius", false);
                resolve()
              })
            }
          }

        }).then(() => {
          setTimeout(() => {
            this.$emit("change_submit_auth_genius", this.order_index);
            this.$emit("increment_submission", this.order_index + 1);
          }, 2000);
        })
      }
    },
    submit_all_workers(val) {
      if (val) {
        for (let a in this.recs) {
          this.recs[a].submit_to_genius = true;
        }
      }
    },
    authorise_all_workers(val) {
      if (val) {
        for (let a in this.recs) {
          this.recs[a].submit_for_auth = true;
        }
      }
    },
  }
}
</script>

<style lang="scss">
.submit_table_v1 {
  .table thead th.firstName, .table thead th.surname, .table thead th.jobTitle {
    z-index: 101;
  }
  .table td.firstName, .table td.surname, .table td.jobTitle, .table td.running_totals {
    z-index: 100;
  }
}
//input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
//  -webkit-appearance: none;
//  margin:             0;
//}
//
//input[type="number"] {
//  -moz-appearance: textfield;
//  //width: 40px !important;
//  width:           100% !important;
//  display:         inline-block !important;
//  vertical-align:  top;
//}
//
//#submit_timesheets_new {
//  .pretty {
//    margin-right: 0;
//    color:        white;
//    height:       22px;
//
//    input {
//      width:      100% !important;
//      height:     22px;
//      max-height: 22px;
//      min-height: 22px;
//    }
//
//    .state {
//      height: 100%;
//
//      .icon {
//        font-size: 1em;
//        left:      0;
//        top:       0;
//      }
//
//      label {
//        text-indent: 1.5em;
//
//        &:before, &:after {
//          height: 22px;
//          width:  22px;
//          top:    0;
//        }
//      }
//    }
//  }
//
//  .pretty input:checked ~ .state .icon, .pretty input:checked ~ .state .svg, .pretty.p-toggle .state .icon, .pretty.p-toggle .state .svg {
//    color:            white;
//    background-color: $bc_1;
//  }
//
//  .table-responsive {
//    height:     auto;
//    max-height: 550px;
//    overflow-y: auto;
//  }
//
//  .sm_btn {
//    line-height:   22px;
//    margin-top:    11px;
//    margin-bottom: 11px;
//  }
//}
//
//.set_all {
//  .set_all_card {
//    padding:       10px;
//    margin:        10px;
//    border:        1px solid $bc_1;
//    border-radius: 5px;
//    display:       inline-block;
//    float:         right;
//  }
//
//  .pretty {
//    .state {
//      color:        $bc_2;
//      margin-right: 20px;
//    }
//  }
//}
//
//.table {
//
//  &.table-striped tbody tr:nth-of-type(odd) {
//    td {
//      background-color: rgba(lighten($bc_5, 15%), 1);
//    }
//  }
//
//  &.table-striped tbody tr:nth-of-type(even) {
//    td {
//      background-color: rgba(lighten($bc_5, 20%), 1);
//    }
//  }
//
//  tr {
//    &.gang_leader {
//      td {
//        background-color: lighten(#FFD734, 25%) !important;
//      }
//    }
//  }
//
//  thead {
//    th {
//      position:           sticky;
//      top:                0;
//      background:         white;
//      z-index:            30;
//      border:             none;
//      -webkit-box-shadow: 0 2px 0 0 $bc_2;
//      -moz-box-shadow:    0 2px 0 0 $bc_2;
//      box-shadow:         0 2px 0 0 $bc_2;
//
//      &.firstName, &.surname {
//        z-index: 31;
//      }
//
//      &.days {
//        height:         180px;
//        white-space:    nowrap;
//        vertical-align: inherit;
//      }
//
//      &.days > div {
//        transform: translate(-2px, 70px) rotate(285deg);
//        width:     30px;
//      }
//
//      &.days > div > span {
//        padding: 0 5px;
//      }
//    }
//  }
//
//  td {
//    position:    relative;
//    height:      45px;
//    line-height: 15px;
//    padding:     0 0.3rem;
//
//    .td_data_outer {
//      height:   45px;
//      display:  block;
//      width:    100%;
//      position: relative;
//    }
//
//    .td_data {
//      position:  absolute;
//      top:       50%;
//      transform: translateY(-50%);
//      width:     100%;
//    }
//
//    input {
//      max-height: 44px;
//    }
//
//    textarea {
//      padding-top:    0.3rem;
//      padding-bottom: 0.3rem;
//
//      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
//        color:   $bc_5;
//        opacity: 1; /* Firefox */
//      }
//
//      &:-ms-input-placeholder { /* Internet Explorer 10-11 */
//        color: $bc_5;
//      }
//
//      &::-ms-input-placeholder { /* Microsoft Edge */
//        color: $bc_5;
//      }
//    }
//
//    input, textarea {
//      border:        1px solid darken($bc_5, 5%);
//      display:       block;
//      height:        100%;
//      width:         100%;
//      min-height:    44px;
//      padding-left:  0.3rem;
//      padding-right: 0.3rem;
//      color:         #212529;
//
//      &:focus {
//        outline:    none;
//        box-shadow: 0 0 10px $bc_3;
//      }
//    }
//
//    .multiselect {
//      width:      calc(100% - 2px);
//      min-height: 42px;
//      height:     42px;
//      border:     1px solid darken($bc_5, 5%);
//
//      .multiselect__tags {
//        min-height:    42px;
//        border-bottom: none;
//
//        input {
//          width:      100% !important;
//          border:     none;
//          min-height: 42px;
//
//          &:focus {
//            box-shadow: none;
//          }
//        }
//      }
//
//      .multiselect__input, .multiselect__single {
//        padding-top: 13px;
//      }
//    }
//
//    .multiselect--active {
//      input {
//        padding-top: 2px;
//      }
//    }
//
//    &.firstName, &.surname, &.running_totals {
//      z-index: 28;
//    }
//
//    &.days, &.additionsDesc, &.deductionsDesc {
//      padding: 0;
//    }
//
//    &.releaseRetention, &.backNextWeek {
//      font-size: 1.25rem;
//      /*z-index:   27;*/
//    }
//
//    &.submitPayroll {
//      font-size: 1.25rem;
//    }
//  }
//
//  .firstName, .surname, .running_totals {
//    min-width: 135px;
//    position:  sticky;
//    left:      0;
//    /*z-index:    85;*/
//    //background: $white;
//  }
//
//  .surname {
//    left: 135px;
//  }
//
//  //.running_totals {
//  //  min-width: 300px;
//  //}
//
//  .jobTitle {
//    min-width: 110px;
//    max-width: 300px;
//  }
//
//  .payRate {
//    max-width: 110px;
//    min-width: 110px;
//  }
//
//  .days {
//    max-width: 60px;
//    min-width: 60px;
//  }
//
//  .totalHours, .releaseRetention, .releaseRetentionAmount {
//    text-align: center;
//    min-width:  100px;
//
//    .td_data {
//      left:      50%;
//      transform: translate(-50%, -50%);
//    }
//  }
//
//  .releaseRetention, .releaseRetentionAmount {
//    min-width: 80px;
//  }
//
//  .hours_invoice {
//    text-align: center;
//    min-width:  75px;
//
//    .td_data {
//      left:      50%;
//      transform: translate(-50%, -50%);
//    }
//  }
//
//  .additionsDesc, .deductionsDesc {
//    max-width: 230px;
//    min-width: 230px;
//  }
//
//  .backNextWeek {
//    max-width:  75px;
//    min-width:  75px;
//    position:   sticky;
//    left:       0;
//    /*z-index:    30;*/
//    //background: white;
//    text-align: center;
//  }
//
//  .submitPayroll {
//    max-width:  75px;
//    min-width:  75px;
//    text-align: center;
//  }
//
//  .totals_row {
//    td {
//      border-color:  $bc_2;
//      border-width:  6px;
//      border-style:  double;
//      border-left:   none;
//      border-right:  none;
//      border-bottom: none;
//      background:    white;
//    }
//
//    .td_data {
//      font-weight: bold;
//    }
//
//    .days, .additionsDesc, .deductionsDesc {
//      padding-left:  0.3rem;
//      padding-right: 0.3rem;
//    }
//  }
//}
</style>
